/* eslint-disable no-unused-vars */
import angular from 'angular';
import token from './token.directive';
import './styles.scss';

export {
  clickHandler,
  compress,
  decompress,
  getTokenHtml,
  mouseDownHandler,
  mouseUpHandler,
  parsePropsFromTokenData,
} from './tokens.service';

export default angular.module('app.components.global.richTextEditor.token', [])
  .directive('rteToken', token)
  .name;

console.log('app.components.global.richTextEditor.token created');
